export default "/assets/images/peacekeeper-hero.6298efd011d729a0.png";